module.exports = __webpack_public_path__ + "img/2.ee58a1f9.png";